import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui';
import type { FallbackChainEntry } from '@/types/service';

interface RoutingStatusBadgeProps {
  fallbackChain?: FallbackChainEntry[];
  gatewayServiceId?: string;
  /** Optional className passthrough (for layout tweaks) */
  className?: string;
}

/**
 * Drei-Zustand-Badge fuer den Routing-Status eines Service (Spec 0216 §5.1):
 *
 *  - gruen ("OK"):      fallbackChain.length >= 1
 *  - gelb  ("Legacy"):  chain leer, aber Legacy-gatewayServiceId vorhanden
 *  - rot   ("fehlt"):   weder Chain noch Legacy-ID — sollte laut Contract
 *                       v1.9 nicht vorkommen, fangen wir defensiv ab.
 */
export function RoutingStatusBadge({
  fallbackChain,
  gatewayServiceId,
  className,
}: RoutingStatusBadgeProps) {
  const { t } = useTranslation('routing');
  const chainLen = fallbackChain?.length ?? 0;

  if (chainLen >= 1) {
    return (
      <Badge variant="success" className={className}>
        {t('status.ok', { count: chainLen })}
      </Badge>
    );
  }

  if (gatewayServiceId) {
    return (
      <Badge variant="warning" className={className}>
        {t('status.legacy')}
      </Badge>
    );
  }

  return (
    <Badge variant="destructive" className={className}>
      {t('status.missing')}
    </Badge>
  );
}
